<svg 
    [ngClass]="IconClass"
    x="0px"
    y="0px"
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14"
    focusable="false">
    <polygon points="2,10 12,10 7,4"></polygon>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-up-arrow.html